import { FC } from "react";

import { Box, useTheme } from "@mui/material";

import { ListenerTagRow } from "@/components/Procedures/Checklist/ListenerTagRow";
import { IStepMeasurements } from "@/components/Procedures/Checklist/utils/Types";
import { styled } from "@mui/material/styles";

export const StepMeasurementListeners: FC<IStepMeasurements> = (props) => {
	const { activeSchemeId, step } = props;
	const theme = useTheme();

	if (props.listenerTags.length === 0 || !props.showMeasurements) {
		return <></>;
	}
	
	return (
		<TagContainer>
			<Box
				sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
				className="grid-row-signal-container"
			>
				{step.ListenerTags.map((listenerTag, key) => (
					<ListenerTagRow
						key={key}
						listenerTag={listenerTag}
						isLast={key === step.ListenerTags.length - 1}
						{...props}
					/>
				))}
			</Box>
		</TagContainer>
	);
};

export const TagContainer = styled(Box)({
	width: "90%",
	position: "relative",
	borderRadius: 4,
	padding: "2px 5px",
	margin: "0 auto",
});
